/**
 * Lightweight, vendor-neutral conversion hook. A future analytics provider can
 * subscribe to this event without coupling the landing page to a platform.
 */
export function trackConversion(event: string, detail: Record<string, string> = {}) {
  window.dispatchEvent(new CustomEvent('talenxa:conversion', { detail: { event, ...detail } }))
}
